import { useGameStore } from '../store/gameStore';

export function Sidebar() {
    const { guessedCount, totalCount, progressPct, guessedCountries } = useGameStore();
    const remaining = totalCount - guessedCount;

    return (
        <section className="overlay-container-left">
            <div id="left-sidebar-content" style={{ color: 'white', fontSize: '18px', padding: '0px 20px' }}>
                <h4>Your Progress</h4>
                <section className="stats-section">
                    <div className="stat-item">
                        <div className="stat-label">CORRECT</div>
                        <div className="stat-value" id="correctCount">{guessedCount}</div>
                    </div>
                    <div className="stat-item">
                        <div className="stat-label">REMAINING</div>
                        <div className="stat-value" id="remainingCount">{remaining}</div>
                    </div>
                </section>
                <section className="progress-section">
                    <div className="progress-header">
                        <span className="progress-label">Progress</span>
                        <span className="progress-percentage" id="progressPercentage">{progressPct}%</span>
                    </div>
                    <div className="progress-bar">
                        <div className="progress-fill" id="progressFill" style={{ width: `${progressPct}%` }} />
                    </div>
                </section>
                <section className="countries-section">
                    <h4 className="countries-title">Countries</h4>
                    <ul id="guessed-countries-list">
                        {guessedCountries.map((c) => (
                            <li key={c.name}>{c.name}</li>
                        ))}
                    </ul>
                </section>
            </div>
        </section>
    );
}
